import { getError } from "@/utils/helpers";
import NplanPhService from "@/services/nplan/NplanPhService";
export const namespaced = true;

export const state = {
  ph_plans: [],
  loading: false,
  error: null,
  status: null,
};

export const mutations = {
  SET_PHPLANS(state, ph_plans) {
    state.ph_plans = ph_plans;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getPHplans({ commit }) {
    commit("SET_LOADING", true);

    NplanPhService.getMains()
      .then((response) => {
        commit("SET_PHPLANS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_PHPLANS", []);
  },
};
export const getters = {
  ph_plans: (state) => {
    return state.ph_plans;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
